// TODO: Add a cart loading state
// TODO: Put this logic in the mini cart component?

import { GA4ProductItem } from '../classes/ga4-classes'
import { getCartItemDetailsForEvent, getLocalStorageCart } from '../helpers/ga4-helpers'
import { GA4Constants } from '../constants/analytics-constants'
import { mapGetters, mapActions } from 'vuex'

export const CartUtils = {
  data() {
    return {
      hasData: false,
      isLoadingCartData: false,
    }
  },
  methods: {
    toggleShowCart() {
      var scrollToElement = $('#commerce-store')
      var container = $('body, html')
      this.toggleCart()
      if (this.showCart) {
        this.$store.dispatch('cart/sendGA4ViewCartEvent', this.findCartItems)
      }
      container.animate({
        scrollTop: scrollToElement.offset().top,
      })
    },
    async getCartData(attributeName, keepCartOpen, onCartDataLoaded, clearReservations = true) {
      var self = this
      var keepOpen = false
      var forceOpen = false
      if (keepCartOpen) {
        keepOpen = keepCartOpen
      }
      if (self.$route.query.cart) {
        forceOpen = self.$route.query.cart
      }

      self.$store.commit('global/setLoadingGroupMembers', true)
      await self.getCartItems(keepOpen, forceOpen, onCartDataLoaded, clearReservations)
    },
    async getCartItems(keepOpen, forceOpen, onCartDataLoaded, clearReservations) {
      try {
        this.isLoadingCartData = true

        // We need to not clear reservations during checkout to avoid assignment issues
        const params = new URLSearchParams({ clearReservations })
        const cartUrl = `/api/minicart?${params}`
        const cartData = await this.fetch({
          url: cartUrl,
        })

        if (cartData) {
          this.hasData = true
          let assignedMembers = []
          let hasUnassigned = false

          /** @type import('../classes/ga4-classes').GA4ShadowCart */
          const shadowCart = {}
          const items = cartData.Items || []
          for (const cartItem of items) {
            cartItem.AssignedTo = this.parseAttributes(cartItem)

            if (!_.isEmpty(cartItem.AssignedToContactInfo)) {
              assignedMembers.push(cartItem.AssignedToContactInfo)
            } else if (!hasUnassigned) {
              hasUnassigned = true
            }

            const { item_category, item_category2 } = await getCartItemDetailsForEvent(cartItem, null)
            const ga4CartItems = cartItem.ProductVariantPricing.map((variant) => {
              return new GA4ProductItem({
                item_id: variant.Slug || null,
                cart_item_id: cartItem.Id || null,
                item_list_id:
                  (variant.IsAddOn ? GA4Constants.ITEM_LISTS.ADD_ONS.ID : cartItem.ProductItemListId) ??
                  GA4Constants.DEFAULT_LIST_ID,
                item_list_name:
                  (variant.IsAddOn ? GA4Constants.ITEM_LISTS.ADD_ONS.ID : cartItem.ProductItemListName) ??
                  GA4Constants.DEFAULT_LIST_NAME,
                item_name: variant.ProductName || null,
                discount: 0,
                coupon: null,
                item_category,
                item_category2,
                item_category3: null,
                item_variant: variant.VariantName || null,
                item_brand: null,
                index: 0, // index is set in events
                price: variant.Price || 0,
                quantity: cartItem.Quantity || 1,
                affiliation: window?.storeSettings?.Store?.Name || GA4Constants.DEFAULT_AFFILIATION,
                sku: variant.Sku,
              })
            })

            shadowCart[cartItem.Id] = ga4CartItems
          }

          localStorage.setItem(GA4Constants.LOCAL_CART_ID, JSON.stringify(shadowCart))

          if (!_.isEmpty(assignedMembers)) {
            assignedMembers = _.uniqBy(assignedMembers, (member) => {
              return member.Id
            })
            const sortedMembers = _.sortBy(assignedMembers, (member) => {
              return member.Id
            })
            const sortedCartByAssignment = _.sortBy(cartData.Items, (item) => {
              return item.AssignedTo
            })
            cartData.AssignedMembers = sortedMembers
            cartData.Items = sortedCartByAssignment
          }

          cartData.HasUnassigned = hasUnassigned

          if (!forceOpen && (cartData.TotalProducts < 1 || !keepOpen)) {
            cartData.showCart = false
          } else {
            cartData.showCart = true
          }

          // Update the brand header cart count until the page gets refreshed with the proper value
          let cartCountElement = document.querySelector('#header-cart-count')
          if (cartCountElement) {
            cartCountElement.textContent = cartData.TotalProducts
          }

          // Used for thredbo. TODO: Make this based on a NOP setting
          let thredboCartCountElement = document.querySelector('.cart-items-count')
          if (thredboCartCountElement) {
            thredboCartCountElement.textContent = cartData.TotalProducts
          }

          this.updateCookie({
            pageName: this.$route.params.subcategory || this.$route.params.category,
            pageUrl: this.$route.path,
          })
          await this.updateCart(cartData)

          if (onCartDataLoaded) {
            await this.setEditCart(false)
            onCartDataLoaded()
          }
        }
      } finally {
        this.isLoadingCartData = false
      }
    },
    parseAttributes(cartItem) {
      if (!cartItem.ProductAttributes) return null

      const attributes = cartItem.ProductAttributes
      var newAttributes = []
      var assignedTo = {}

      // Check if a product is a Golf product
      // Used for conditional display
      if (
        cartItem.AttributeInfo.toUpperCase().includes('DATE:') &&
        cartItem.AttributeInfo.toUpperCase().includes('TIME:') &&
        cartItem.AttributeInfo.toUpperCase().includes('HOLES:')
      ) {
        this.$set(cartItem, 'IsGolfProduct', true)
      } else {
        this.$set(cartItem, 'IsGolfProduct', false)
      }

      for (let attribute of attributes) {
        // If attributeValueName is null, use attributeValueId instead
        const attrValue =
          attribute.ProductAttributeValueName !== null
            ? attribute.ProductAttributeValueName
            : attribute.ProductAttributeValueId?.toString()
        const uAttribute = {
          name: attribute.ProductAttributeName || '',
          value: attrValue?.split(/\|(.+)/)[0].trim() || '',
          IsDate: attribute.IsDate,
          IsAssignedTo: attribute.IsAssignedTo,
          IsActivityTime: attribute.IsActivityTime,
          IsLockId: attribute.ProductAttributeName?.toUpperCase() === 'LOCK ID',
          IsReservationTime: false,
          IsReservationHoles: false,
          IsPrice: false,
        }

        // Check if the attribute is the assigned to field
        if (
          attribute.IsAssignedTo &&
          cartItem.AssignedToContactInfo &&
          cartItem.AssignedToContactInfo.Id === attribute.ProductAttributeValueId
        ) {
          assignedTo = {
            Id: uAttribute.value,
            Name: cartItem.AssignedToContactInfo.Fullname,
          }
        }

        if (cartItem.IsGolfProduct) {
          uAttribute.IsReservationTime = attribute.ProductAttributeName.toUpperCase().includes('TIME')
          uAttribute.IsReservationHoles = attribute.ProductAttributeName.toUpperCase().includes('HOLES')
          if (attribute.ProductAttributeName.toUpperCase().includes('RESERVATION PRICE')) {
            uAttribute.IsPrice = true
            const resPrice = cartItem.Quantity * Number(attribute.ProductAttributeValueName)
            this.$set(cartItem, 'ReservationPrice', resPrice)
          }
        }
        newAttributes.push(uAttribute)
      }

      cartItem.Attributes = newAttributes

      return assignedTo
    },
    ...mapActions({
      toggleCart: 'cart/toggleCart',
      updateCart: 'cart/updateCart',
      setEditCart: 'cart/setEditCart',
      updateCookie: 'global/updateCookie',
      fetch: 'api/get',
    }),
  },
  computed: {
    ...mapGetters({
      selectedCategoryId: 'products/selectedCategoryId',
      products: 'products/selectedProduct',
      showCart: 'cart/showCart',
      category: 'products/category',
      categories: 'products/categories',
      cart: 'cart/cart',
      cartItemCount: 'cart/cartItemCount',
      cartHash: 'cart/cartHash',
      subAttributeDelimiter: 'cart/getOrderSubAttributeDelimiter',
      subAttributeKeyword: 'cart/getOrderSubAttributeKeyword',
    }),
    findCartItems() {
      return this.cart.Items
    },
    categoryName() {
      return this.category.Name
    },
  },
}
